export default "__VITE_ASSET__DtiBZ2aP__"